import React from 'react'

const Experience = () => {
    return (
        <div id="experience" className="experience">
            <div className="d-flex justify-content-center my-5">
                <h1>experience</h1>
            </div>
            <div className="container experience-wrapper">
{/*--------------------------------------------------------------------------------------------*/}
                <div className="timeline-block timeline-block-left">
                    <div className="marker"></div>
                    <div className="timeline-content">
                        <h3>2011-2012</h3>
                            <p>
                                <strong>Technical Support Analyst:</strong> Harvard Law School 
                            </p>
                            <p>Cambridge, MA</p>
                            <p>
                                I delivered award winning technical support services
                                to Harvard Law School faculty and staff members.
                            </p>
                            <p>
                                Service Excellence Award
                            </p>
                    </div>
                </div>

{/*--------------------------------------------------------------------------------------------*/}
            
                <div className="timeline-block timeline-block-right">
                    <div className="marker"></div>
                    <div className="timeline-content">
                        <h3>2013</h3>
                            <p>
                                <strong>Bachelor of Science, Neuroscience:</strong> Northeastern University
                            </p>
                            <p>Cambridge, MA</p>
                            <p>
                                Dean's Scholar, Dean's List
                            </p>
                    </div>
                </div>
{/*--------------------------------------------------------------------------------------------*/}
                <div className="timeline-block timeline-block-left">
                    <div className="marker"></div>
                    <div className="timeline-content">
                        <h3>2013-2016</h3>
                            <p>
                                <strong>Technical Support Engineer/ Consultant:</strong> Surfmerchants LLC
                            </p>
                            <p>Boston, MA</p>
                            <p>
                                Oversaw mobile product adoption for our company's largest clients
                            </p>
                            <p>
                                Worked directly with customers to build relationships and resolve 
                                implementation needs with our platform
                            </p>
                            <p>
                                Successfully navigated the intricacies of HTML, CSS, JavaScript, MySQL and relational databases
                            </p>
                            <p>
                                Delivered a company-wide instructional product presentation to all clients
                                at our biennial conference.
                            </p>
                            <p>
                                Worked directly with some of our largest clients in Europe, South America, and
                                the Middle East.
                            </p>
                    </div>
                </div>
{/*--------------------------------------------------------------------------------------------*/}
                <div className="timeline-block timeline-block-right">
                    <div className="marker"></div>
                    <div className="timeline-content">
                        <h3>2016-2018</h3>
                            <p>
                                <strong>Master of Science, Data Science:</strong> City, University of London
                            </p>
                            <p>London, United Kingdom</p>
                            <p>
                                Coursework: Principles of Data Science, Machine Learning, Neural Computing, 
                                Software Agents, Big Data
                            </p>
                            <p>
                                Built an independent-learning agent to navigate a maze with obstacles using
                                an optimized reward function
                            </p>
                            <p>
                                Optimized a machine learning algorithm to predict the value of bank customers
                                as a function of repayment history vs. account value (mock scenario using purely
                                anonymous historical data)
                            </p>
                    </div>
                </div>
{/*--------------------------------------------------------------------------------------------*/}
                <div className="timeline-block timeline-block-left">
                    <div className="marker"></div>
                    <div className="timeline-content">
                        <h3>2018-2019</h3>
                            <p>
                                   Sudden loss in the family, bereavement and illness
                            </p>
                    </div>
                </div>
{/*--------------------------------------------------------------------------------------------*/}
                <div className="timeline-block timeline-block-right">
                    <div className="marker"></div>
                    <div className="timeline-content">
                        <h3>2019</h3>
                            <p>
                                <strong>Full-Stack Web Development Certificate: </strong>University of New Hampshire
                            </p>
                            <p>
                                Portsmouth, NH
                            </p>
                            <p>
                                Developed the skills and knowledge to build a full-stack web application using the MERN stack
                                of software development tools. Concepts covered included: REST APIs, HTTP, CRUD development, MVC architecture, 
                                and advanced JavaScript
                            </p>
                            <p>
                                Ushered a full-functioning web application from idea to reality and presented the final product 
                                to real industry stakeholders
                            </p>
                            <p>
                                Learned back-end web development skills and polished existing front-end skills 
                            </p>
                    </div>
                </div>
{/*--------------------------------------------------------------------------------------------*/}

                <div className="timeline-block timeline-block-left">
                    <div className="marker"></div>
                    <div className="timeline-content">
                        <h3>2020-Present</h3>
                            <p>
                                <strong>Technical Consultant: </strong> HubSpot
                            </p>
                            <p>
                                Cambridge, MA
                            </p>
                            <p>
                                Work directly with customers to build business relationships and help solve their 
                                ongoing HubSpot implementation, integration, and support needs
                            </p>
                            <p>
                                Apply problem solving and solution design skills to remedy internal roadblocks for 
                                customers, enabling them to get the maximum value from the HubSpot software
                            </p>
                            <p>
                                Consult on advanced HubSpot usage, front-end work, and client integration needs such as: 
                                REST API development, iPaaS solution implementations, and OAuth authentication
                            </p>
                            <p>
                                Partner with other consultants on shared customers to manage their strategic and 
                                technical requirements 
                            </p>
                    </div>
                </div>


{/*--------------------------------------------------------------------------------------------*/}
            </div>
        </div>
    )
}

export default Experience
